import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

import Logo from "../logo"
import Toggle from "../toggle"
import Menu from "../menu/menu"
import * as styles from "./navbar.module.css"
import { testIds } from "../../common/constants"
import useNavbar from "./use-navbar"
import classNames from "classnames"
import MainNavigation from "../menu/main-navigation"

const Navbar = () => {
  const { highlighted, menuOpen, toggleMenu } = useNavbar()

  const data = useStaticQuery(graphql`
    query {
      contentfulConfig(title: { eq: "W3" }) {
        pages {
          id
          title
          slug
        }
        socialMediaChannels {
          id
          title
          url
        }
      }
    }
  `)

  const config = data.contentfulConfig

  const stickyBarClassName = classNames(styles.stickyBar, {
    [styles.highlighted]: highlighted,
    [styles.open]: menuOpen,
  })

  return (
    <>
      <div className={stickyBarClassName}>
        <div className="container">
          <div className="columns">
            <div className="column is-12">
              <div className={styles.stickyBarContent}>
                <Link
                  to="/"
                  aria-label="Wunderdog home"
                  data-test-id={testIds.global.header.logo}
                >
                  <Logo inverse={menuOpen} small={highlighted} />
                </Link>
                <MainNavigation
                  className={styles.mainNavigation}
                  linkClassName={styles.mainNavigationLink}
                  activeLinkClassName={styles["mainNavigationLink__active"]}
                  pages={config.pages}
                />
                <Toggle
                  className={styles.toggle}
                  onClick={toggleMenu}
                  active={menuOpen}
                  bright={menuOpen}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Menu config={config} active={menuOpen} toggleMenu={toggleMenu} />
    </>
  )
}

export default Navbar
